const getDefaultJitaiSetting = () => {
  return {
    task_name: '',
    collecting_responses: [], // Array of response collection configurations
    pre_message_observations: {
      qx_resp: null, // Optional ObjectId of a JitaiResp with resp_type='qx'
      custom_resps: [], // Array of { jitai_resp: ObjectId } where resp_type='custom'
    },
    prompt_time_type: '', // 'Fixed' or 'Variable'
    prompt_time: '09:00', // HH:mm format, 24-hour
    prompt_variable: null,
    timezone: 'Hongkong',
    expiry_duration_minutes: 30, // Default: 30 minutes
    message_settings: [], // Array of message configurations
  }
}

export default getDefaultJitaiSetting

